import { tokenInstance } from '@pequity/shared/axios/token';
import { defineStore } from 'pinia';

type AppConfig = {
  aimOidcEnabled: boolean;
  aimOidcLogoutEndpoint: string;
  aimOidcClientId: string;
  aimSmCookieRefreshUrl: string;
  tenantSubdomainsEnabled: boolean;
  frontendBaseUrl: string;
  clientType: string;
};

export const useAppConfigStore = defineStore('appConfig', {
  state: (): AppConfig & { isLoaded: boolean } => ({
    isLoaded: false,
    aimOidcEnabled: false,
    aimOidcLogoutEndpoint: '',
    aimOidcClientId: '',
    aimSmCookieRefreshUrl: '',
    tenantSubdomainsEnabled: true,
    frontendBaseUrl: '',
    clientType: '',
  }),
  getters: {
    shouldRedirectToOidc: (state): boolean => state.aimOidcEnabled,
    showTenantFinder: (state): boolean => state.tenantSubdomainsEnabled,
    showPublicLogin: (state): boolean => !state.tenantSubdomainsEnabled && !state.aimOidcEnabled,
  },
  actions: {
    async fetchAppConfig() {
      if (this.isLoaded) return;

      try {
        const { data } = await tokenInstance.get('/app-config/');

        this.aimOidcEnabled = data.aim_oidc_enabled;
        this.aimOidcLogoutEndpoint = data.aim_oidc_logout_endpoint;
        this.aimOidcClientId = data.aim_oidc_client_id;
        this.aimSmCookieRefreshUrl = data.aim_sm_cookie_refresh_url;
        this.tenantSubdomainsEnabled = data.tenant_subdomains_enabled;
        this.frontendBaseUrl = data.frontend_base_url;
        this.clientType = data.client_type;
        this.isLoaded = true;
      } catch {
        console.error('Failed to load app config');
      }
    },
  },
});
